var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1314 4.26218C16.5817 3.49909 14.571 3.05744 12.4299 3.00526C12.2871 3.00176 12.1437 3 11.9998 3C9.69904 3 7.52161 3.44824 5.86862 4.26218C4.01874 5.17297 3 6.45315 3 7.86688V16.1332C3 17.547 4.01874 18.8271 5.86862 19.7379C7.52161 20.5518 9.6991 21 11.9998 21C14.3005 21 16.4779 20.5518 18.131 19.7379C19.9808 18.8271 20.9995 17.547 20.9995 16.1332V7.88779C20.9995 7.88457 20.9996 7.88137 20.9998 7.87816C20.9999 7.8744 21 7.87063 21 7.86682C21 6.45318 19.9813 5.17297 18.1314 4.26218ZM19.163 7.8825C19.1529 8.57935 18.4747 9.30991 17.298 9.8892C15.8982 10.5784 14.0168 10.958 12.0003 10.958C9.98368 10.958 8.1022 10.5784 6.70246 9.8892C5.51689 9.30556 4.83691 8.56847 4.83691 7.86688C4.83691 7.16532 5.51692 6.42808 6.7024 5.84438C8.10214 5.1552 9.9835 4.77561 12 4.77556C14.0163 4.77556 15.8977 5.15517 17.2975 5.84438C18.483 6.42808 19.163 7.16523 19.163 7.86688V7.8825ZM15.6 7.95C15.6 8.69558 13.9882 9.3 12 9.3C10.0118 9.3 8.4 8.69558 8.4 7.95C8.4 7.20442 10.0118 6.6 12 6.6C13.9882 6.6 15.6 7.20442 15.6 7.95Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.516ba2fd46d972ac1865aa9c79d87bb8.svg";
export { ForwardRef as ReactComponent };